export const opcoesRegimeCasamento = [
    {label: 'Comunhão parcial de bens', value: 1},
    {label: 'Comunhão total de bens', value: 2},
    {label: 'Separação total de bens', value: 3}
]